var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"text-center"},[(_vm.additive)?_c('Additive'):_c('PathDependent'),_c('br')],1),_c('BottomBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }